import React from 'react';
import Hero from './Hero';
import Privacy from './Privacy';
import FeaturesSummary from './Features'; // The shorter summary for Home
import ShareGallery from './ShareGallery';

const Home = () => {
  return (
    <>
      <Hero />
      <Privacy />
      <FeaturesSummary />
      <ShareGallery />
    </>
  );
};

export default Home;